import { Popover, Transition } from "@headlessui/react"
import { ArrowLeftIcon, CheckIcon, InformationCircleIcon } from "@heroicons/react/24/outline"
import { Button, Checkbox, Group, Radio } from "@mantine/core"
import React from "react"
import { useContentContext } from "../utils/ContentProvider"
import {
	getIncludedOptions,
	getLevelOptions,
	getResultCountForLevelOfCover,
	getVisibleValue,
	partnerOptions
} from "../utils/options"
import { ResultFilterProps } from "../utils/types"

const ResultFilters = (props: ResultFilterProps) => {
	const { lang, translations } = useContentContext()
	const resultsForCounts = props.allResults ?? props.results

	const seenCommonNames = new Set()

	const filterOptions = props.filterOptions.filter((option) => {
		if ( seenCommonNames.has(option.commonName) ) {
			return false
		}
		seenCommonNames.add(option.commonName)
		return true
	})

	const goToDetails = () => {
		props.handleGoBack()
	}

	return (
		<>
			<div className="flex flex-row items-center justify-start pt-2 pl-4 mb-6">
				<Button
					variant="light"
					color="gray"
					radius="l"
					leftSection={
						<ArrowLeftIcon className="w-4 h-4 text-gray-500"/>
					}
					onClick={ () => goToDetails() }
					className="min-w-[140px]"
				>
					{ translations.results.goBack }
				</Button>
			</div>
			{ props.plateNumber &&
        <div
          className="flex flex-col items-center justify-center p-6 mx-4 my-2 border border-gray-300 rounded-md bg-white shadow">
          <div className="font-bold">
						{ translations.results.yourRegistrationNumber }
          </div>
          <div className="font-medium">
						{ props.plateNumber.toUpperCase() }
          </div>
        </div>
			}
			{/*<div*/ }
			{/*	className="flex flex-col items-center justify-center space-y-2 p-6 mx-4 my-2 border border-gray-300 rounded-md bg-white shadow">*/ }
			{/*	<div className="font-bold">*/ }
			{/*		Mini (BMW)*/ }
			{/*	</div>*/ }
			{/*	<div className="font-normal">*/ }
			{/*		Cooper Clubman 1.6*/ }
			{/*	</div>*/ }
			{/*	<div className="font-normal">*/ }
			{/*		122 PS (90 kW)*/ }
			{/*	</div>*/ }
			{/*</div>*/ }
			<div
				className="flex flex-col items-start justify-center p-6 mx-4 my-2 border border-gray-300 rounded-md bg-white shadow">
				<fieldset className="w-full">
					<legend
						className="flex flex-row items-center mb-4 text-sm font-bold leading-6 text-gray-900">
						{ translations.results.levelOfCoverTitle }
						<Popover className="relative ml-2">
							<Popover.Button>
								<InformationCircleIcon className="w-4 h-4"/>
							</Popover.Button>
							<Transition
							>
								<Popover.Panel className="absolute z-10 left-8 -top-10">
									<div
										className="flex flex-wrap w-64 p-4 border border-gray-300 rounded-md bg-white text-sm text-gray-900 font-normal shadow">
										<p
											style={ { whiteSpace: 'pre-line' } }>{ translations.results.levelOfCoverMoreInformation }</p>
									</div>
								</Popover.Panel>
							</Transition>
						</Popover>
					</legend>
					<div className="flex flex-col space-y-2">
						<Group>
							{ getLevelOptions(translations.results.levelOfCoverTitles)
								.sort((a, b) => a.order.localeCompare(b.order))
								.map((option) => (
									<div className="flex w-full items-center ml-3" key={ "levelOption" + option.id }>
										<Radio
											checked={ option.id === props.currentLevelOfCover }
											onChange={ (event: any) => {
												props.handleLevelOfCover(event.target.id)
											} }
											id={ option.id }
											name="notification-method"
											type="radio"
											className="w-5 h-5 border-gray-300 text-blue-600 focus:ring-blue-600"
										/>
								<label htmlFor={ option.id }
													 className="ml-3 block text-sm font-normal leading-6 text-gray-900">
											{ option.title } ({ getResultCountForLevelOfCover(option.title, resultsForCounts) })
										</label>
									</div>
								)) }
						</Group>
					</div>
				</fieldset>
			</div>
			<div
				className="flex flex-col items-start justify-center p-6 mx-4 my-2 border border-gray-300 rounded-md bg-white shadow">
				<fieldset className="w-full">
					<legend
						className="flex flex-row items-center mb-4 text-sm font-bold leading-6 text-gray-900">
						{ translations.results.partnersTitle }
						<Popover className="relative ml-2">
							<Popover.Button>
								<InformationCircleIcon className="w-4 h-4"/>
							</Popover.Button>
							<Transition
							>
								<Popover.Panel className="absolute z-10 left-8 -top-10">
									<div
										className="flex flex-wrap w-64 p-4 border border-gray-300 rounded-md bg-white text-sm text-gray-900 font-normal shadow">
										<p
											style={ { whiteSpace: 'pre-line' } }>{ translations.results.partnersMoreInformation }</p>
									</div>
								</Popover.Panel>
							</Transition>
						</Popover>
					</legend>
					<div className="flex flex-col space-y-2 mb-4">
						<Group>
							{ partnerOptions.map((partner, index) => (
									<div key={ "Optional" + partner + index }
											 className="flex items-center w-full ml-3">
										<Checkbox
											id={ partner.id }
											name={ "Partner" + partner.id }
											type="checkbox"
											checked={ props.currentPartners.includes(partner.title) }
											className="w-5 h-5 border-gray-300 text-blue-600 focus:ring-blue-600"
											onChange={ (event: any) => {
												props.handlePartner(partner.title)
											} }
										/>
										<label htmlFor={ partner.title }
													 className="ml-3 block text-sm font-normal leading-6 text-gray-900">
											{ partner.title }
										</label>
									</div>
								)
							)
							}
						</Group>
					</div>
				</fieldset>
			</div>
			{ ![ "", "kaikki" ].includes(props.currentLevelOfCover) &&
        <div
          className="flex flex-col items-start justify-center p-6 mx-4 my-2 border border-gray-300 rounded-md bg-white shadow">
          <fieldset className="w-full">
            <legend
              className="flex flex-row items-center mb-4 text-sm font-bold leading-6 text-gray-900">
							{ translations.results.filterByCoverTitle }
              <Popover className="relative ml-2">
                <Popover.Button>
                  <InformationCircleIcon className="w-4 h-4"/>
                </Popover.Button>
                <Transition
                >
                  <Popover.Panel className="absolute z-10 left-8 -top-10">
                    <div
                      className="flex flex-wrap w-64 p-4 border border-gray-300 rounded-md bg-white text-sm text-gray-900 font-normal shadow">
											{ translations.results.filterByCoverMoreInformation }
                    </div>
                  </Popover.Panel>
                </Transition>
              </Popover>
            </legend>
						{ props.currentLevelOfCover !== "kaikki" &&
              <>
                <div className="flex flex-col space-y-2">
                  <div className="flex flex-row text-sm font-medium border-b mb-3 pb-1">
										{ translations.results.includedTitle }
                    <Popover className="relative ml-2">
                      <Popover.Button>
                        <InformationCircleIcon className="w-4 h-4"/>
                      </Popover.Button>
                      <Transition>
                        <Popover.Panel className="absolute z-10 left-8 -top-10">
                          <div
                            className="flex flex-wrap w-64 p-4 border border-gray-300 rounded-md bg-white text-sm text-gray-900 font-normal shadow">
														{ translations.results.includedMoreInformation }
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </Popover>
                  </div>
                </div>
                <div className="flex flex-col space-y-2 mb-4">
									{ getIncludedOptions(props.currentLevelOfCover)
										.sort((a, b) => a.title.localeCompare(b.title))
										.map((option) => {
											const visibleValue = getVisibleValue(option.title, lang)

											return (
												<div key={ option.title } className="flex items-center">
													<label htmlFor={ option.title }
																 className="flex flex-row items-center ml-3 block text-sm font-normal leading-6 text-gray-500">
														<CheckIcon
															className="w-4 h-4 mr-2"/> { visibleValue }
													</label>
												</div>
											)
										})
									}
                </div>
              </>
						}
						{ props.currentLevelOfCover !== "liikenne" &&
              <>
                <div className="flex flex-col space-y-2">
                  <div className="flex flex-row text-sm font-medium border-b mb-3 pb-1">
										{ translations.results.optionalTitle }
                    <Popover className="relative ml-2">
                      <Popover.Button>
                        <InformationCircleIcon className="w-4 h-4"/>
                      </Popover.Button>
                      <Transition>
                        <Popover.Panel className="absolute z-10 left-8 -top-10">
                          <div
                            className="flex flex-wrap w-64 p-4 border border-gray-300 rounded-md bg-white text-sm text-gray-900 font-normal shadow">
														{ translations.results.optionalMoreInformation }
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </Popover>
                  </div>
                </div>
                <div className="flex flex-col space-y-2 mb-4">
									{/*
									4) Suodata ei toimi oikein (lasi, lunastus, luonnonilmiö, parkki) => esim. Turva tippuu pois, jos valitsee lasin, mutta palautuu jos valitsee lasin, lunastuksen ja luonnonilmiön)
									*/ }
                  <Group>
										{ filterOptions
											.sort((a, b) => a.name.localeCompare(b.name))
											.filter((option) => {
												if ( props.currentLevelOfCover === "osakasko" ) {
													return [ "Ilkivalta", "Luonnonilmiö" ].includes(option.commonName)
												} else if ( props.currentLevelOfCover === "täyskasko" ) {
													return [ "Lasi", "Luonnonilmiö", "Lunastus", "Pysäköinti" ].includes(option.commonName)
												} else if ( props.currentLevelOfCover === "liikenne" ) {
													return false
												} else if ( props.currentLevelOfCover === "kaikki" ) {
													return true
												}
											})
											.map((option, index) => {
													const visibleValue = getVisibleValue(option.commonName, lang)

													if ( ![ "Rahoitusturva", "Rengasturva" ].includes(visibleValue) ) {
														return (
															<div key={ "Optional" + option + index }
																	 className="flex items-center w-full ml-3">
																<Checkbox
																	// label="I agree to sell my privacy"
																	id={ option.name }
																	name={ "Optional" + option }
																	type="checkbox"
																	checked={ props.currentOptional.includes(option.name) }
																	className="w-5 h-5 border-gray-300 text-blue-600 focus:ring-blue-600"
																	onChange={ (event: any) => {
																		props.handleOptional(event.target.id)
																	} }
																/>
																<label htmlFor={ option.name }
																			 className="ml-3 block text-sm font-normal leading-6 text-gray-900">
																	{ visibleValue }
																</label>
															</div>
														)
													}
												}
											)
										}
                  </Group>
                </div>
              </>
						}
          </fieldset>
        </div>
			}
		</>
	)
}

export default ResultFilters
